import React from 'react';
import { features } from '../mock';
import {
  MonitorSmartphone,
  BarChart3,
  Trophy,
  BookOpen,
  FileText,
  Smartphone,
  Star,
} from 'lucide-react';

const iconMap = { MonitorSmartphone, BarChart3, Trophy, BookOpen, FileText, Smartphone };

export default function Features() {
  return (
    <section id="features" className="py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-emerald-500/30 bg-emerald-500/5 text-emerald-300 text-xs font-semibold">
            <Star size={12} /> Premium Features
          </div>
          <h2 className="mt-4 text-4xl md:text-5xl font-extrabold text-white tracking-tight">
            Why Students Choose Us
          </h2>
          <p className="mt-3 text-slate-400">Everything you need to ace your exams</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => {
            const Icon = iconMap[f.icon];
            return (
              <div
                key={f.title}
                className="group rounded-xl border border-white/5 bg-[#0f1725] hover:border-emerald-500/40 transition-all duration-300 p-7"
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-emerald-500/20 to-teal-500/10 border border-emerald-500/30 flex items-center justify-center mb-5 group-hover:scale-105 transition-transform">
                  <Icon className="text-emerald-400" size={26} />
                </div>
                <h3 className="text-white font-bold text-xl">{f.title}</h3>
                <p className="mt-2 text-slate-400 text-sm leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
